import { useEffect } from "react";
import { siteMeta } from "@/mocks/chigua";

interface SeoProps {
  title: string;
  description: string;
  path?: string;
  keywords?: string;
  image?: string;
}

function setMeta(name: string, content: string) {
  if (!content) return;
  let el = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}

function setProperty(property: string, content: string) {
  if (!content) return;
  let el = document.head.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.content = content;
}

export default function useSeo({ title, description, path = "/", keywords, image }: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords ?? siteMeta.keywords);
    const url = `${siteMeta.domain}${path}`;
    const canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) canonical.href = url;
    setProperty("og:title", title);
    setProperty("og:description", description);
    setProperty("og:url", url);
    if (image) setProperty("og:image", image);
    setProperty("twitter:title", title);
    setProperty("twitter:description", description);
  }, [title, description, path, keywords, image]);
}